import { useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { getDoc, updateDoc, doc } from "firebase/firestore"
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db } from "../../firebase"
import Header from '../HeaderAdmin';


const Edit = () => {
    const [ titulo, setTitulo ] = useState('')
    const [ cantidad, setCantidad ] = useState(0)
    const [ descripcion, setDescripcion ] = useState('')
    const [ url, setUrl ] = useState('')
    const [imagen, setImagen] = useState();

    const navigate = useNavigate()    
    const {id} = useParams()

    const storage = getStorage();
 

 

    const update = async (e) => {
        e.preventDefault()
        const slide = doc(db, "inventario", id)
        const data = {nombre: titulo, url: url, cantidad:cantidad, descripcion:descripcion}
        await updateDoc(slide, data)
        navigate('/admin-inventario')
    }

    const getProductById = async (id) => {
        const slide = await getDoc( doc(db, "inventario", id) )
        if(slide.exists()) {
            //console.log(product.data())
            setTitulo(slide.data().nombre)    
            setUrl(slide.data().url)
            setDescripcion(slide.data().descripcion)
            setCantidad(slide.data().cantidad)
        }else{
            console.log('El producto no existe')
        }
    }

    //FUNCION PARA GUARDAR LA IMAGEN EN FIREBASE
    const uploadImage = async () => {
          try {
            const storageRef = ref(storage, imagen.name);
            uploadBytes(storageRef, imagen).then((snapshot) => {
              console.log('Uploaded a blob or file!');
            getDownloadURL(snapshot.ref).then((url)=>{setUrl(url)})
            });
          } catch (error) {
              alert(error);
          }
      };

    const changeImagen =(e) =>{
      setImagen(e.target.files[0]);
    }


    useEffect( () => {
        getProductById(id)
        // eslint-disable-next-line
    }, [])

    return (
        <div className='container'>
            <Header/>
        <div className='row'>
            <div className='col'>
            <h1>Editar Elemento del Inventario</h1>
                 <form onSubmit={update}>
                  
                    <div className='mb-3'>
                        <label className='form-label'>Nombre</label>
                        <input
                            value={titulo}
                            onChange={ (e) => setTitulo(e.target.value)} 
                            type="text"
                            className='form-control size'
                        />
                    </div>

                                      
                    <div className='mb-3'>
                        <label className='form-label'>Cantidad</label>
                        <input
                            value={cantidad}
                            onChange={ (e) => setCantidad(e.target.value)} 
                            type="number"
                            className='form-control size'
                        />
                    </div>  

                    <div className='mb-3'>
                        <label className='form-label'>Descripcion</label>
                        <input
                            value={descripcion}
                            onChange={ (e) => setDescripcion(e.target.value)} 
                            type="text"
                            className='form-control size'
                        />
                    </div>    

                    <div className='mb-3'>
                        <label className='form-label'>Slide</label>
                        <input
                            type="file"
                            name="imagen"
                            onChange={changeImagen}
                            className='form-control'
                        />                 
                    </div> 
                    <div className="btn btn-primary" onClick={uploadImage}>UploadIMG</div> 
                    <button className='btn btn-success' >Update</button>
                 </form>   
            </div>
        </div>
    </div> 
    )
}

export default Edit